import axios from "axios";

const API_URL = import.meta.env.VITE_CRM_API_URL || "https://dashboard.lono.co.in/api";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Token interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const staffPortalApi = {
  // Get leads by multiple statuses for a staff member
  getLeadsByStatusforStaff: async (status, staffId) => {
    if (!staffId || !status) {
      throw new Error("Invalid staff ID or status");
    }

    try {
      const response = await api.get(`/crm/staff/leads/status/${status}`, {
        headers: {
          staffId,
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Assign loan to credit manager
  assignLoanToCreditManager: async (loanId) => {
    if (!loanId) {
      throw new Error("Loan ID  is required");
    }

    try {
      const response = await api.patch(
        `/loans/${loanId}/assign-credit-manager`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get leads by status for a banking partner
  getLeadsByStatusForBankingPartner: async (status, bankingPartnerId) => {
    if (!status || !bankingPartnerId) {
      throw new Error("Status and Banking Partner ID are required");
    }

    try {
      const response = await api.get(`/crm/bp/leads/status/${status}`, {
        headers: {
          bankingpartnerid: bankingPartnerId,
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get leads by status for a Credit Manager
  getLeadsByStatusforCM: async (status, staffId) => {
    if (!status || !staffId) {
      throw new Error("Status and Staff ID are required");
    }
    console.log(staffId, "api");
    try {
      const response = await api.get(`/crm/cm/leads/status/${status}`, {
        headers: {
          staffId,
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all leads for a specific staff member
  getLeadsByStaff: async (staffId) => {
    if (!staffId) {
      throw new Error("Staff ID is required");
    }

    try {
      const response = await api.get(`/crm/leads/staff/${staffId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};
